import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import nlLocale from '@fullcalendar/core/locales/nl';
//import timeGridPlugin from '@fullcalendar/timegrid';
//import listPlugin from '@fullcalendar/list';

import moment from 'moment';

//document.addEventListener('DOMContentLoaded', function() {
$(function () {
    /*
     * The pages for reservations are reused but may need a perticular calendar.
     * Following test determines which calendar to be rendered, based on the content of the 
     * hidden field.
     * This value in turn was set in the Index method from the EventReservationController.
     * 
     * This calendar will only be rendered for a "ENTRY-DAILY" value of the calendar type (Toegangs ticket)
     */
    if ($("#calendarType").val() !== "ENTRY-DAILY") {
        return false;
    }


    var calendarEl = $('#entryCalendar')[0];

    let productSubGroup = $('#ProductSubGroup').val();
    let selectedMonthDate = null;
    let selectedDate = null;

    var calendar = new Calendar(calendarEl, {
        locale: nlLocale,
        validRange: {
            start: moment().format("YYYY-MM-01"),
            end: moment().format("2050-12-31")
        },

        plugins: [interactionPlugin, dayGridPlugin],
        header: {
            right: 'prev,today,next',
            //center: 'title', 
            //right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
            //right: 'dayGridMonth, dayGridWeek'
            left: 'title'
        },

        // Refresh the calender events on Rendereing
        datesRender: function (info) {
            selectedMonthDate = info.view.currentStart;

            // Clear calendar
            $.each(calendar.getEvents(), function (i, event) {
                event.remove();
            });


            $.ajax({
                url: 'eventReservation/getcalendardata?productSubGroup=' + productSubGroup + '&startdate=' + moment(selectedMonthDate).format('YYYY-MM-DD'),
                type: 'GET',

                success: function (data, status) {
                    $.each(data, function (i, d) {
                        let now = moment();
                        let occupation = 0;
                        if (d.ReservedPlaces === 0) {
                            occupation = 0;
                        } else {
                            occupation = Math.round((d.AvailablePlaces - d.NrFreePlaces) / d.AvailablePlaces * 100);
                        }

                        //if (!moment(d.Date).isBefore(now.format('YYYY-MM-DD'), 'day')) {
                        if (!moment(d.Date + 'T' + d.EndTime).isBefore(moment().format())) {


                            if (d.NrFreePlaces > 0) {
                                calendar.addEvent({
                                    id: d.EventId,
                                    //title: 'Beschikbare plaatsen: ' + (d.AvailablePlaces - d.ReservedPlaces),
                                    title: d.NrFreePlaces + ' / ' + d.AvailablePlaces + ' Pl.',
                                    start: d.Date,
                                    color: occupation < 40 ? 'green' : occupation < 90 ? 'orange' : 'orange',
                                    allDay: true
                                });
                            }
                            else {
                                calendar.addEvent({
                                    id: -999,
                                    title: 'Volzet',
                                    start: d.Date,
                                    color: 'red',
                                    allDay: true
                                });
                            }
                        }
                    });

                    console.log(data);
                },
                error: function (xhr, status, error) {
                    ////console.log(xhr.responseText);
                    $('*').removeClass('busy');
                }
            });
        },

        eventClick: function (info) {

            info.jsEvent.preventDefault();

            if (info.event.id === '-999') {
                return false;
            }

            $(".selected-slot").html("Reservatie voor " + moment(info.event.start).format('DD-MM-YYYY'));

            $('#WizardStep0Container').hide();

            $.ajax({
                url: 'eventReservation/GetEventData?productid=' + productSubGroup + '&date=' + moment(info.event.start).format('YYYY-MM-DD') + '&eventid=' + info.event.id,
                type: 'GET',

                success: function (data, status) {
                    HandleStep1FetchResult(data);
                    $('#WizardStep1Container').show();
                    //console.log(data);
                },
                error: function (xhr, status, error) {
                    ////console.log(xhr.responseText);
                    $('*').removeClass('busy');
                }
            });
        },

        // Get the relevant product data
        //dateClick: function (info, allDay, jsEvent, view) {

        //  let events = calendar.getEvents();
        //  let eventId = 0;
        //  var x = events.filter(d => moment(d.start).isSame(moment(info.date)));
        //  // check if there are events for this date, if not bail out
        //  if (events.filter(d => moment(d.start).isSame(moment(info.date))).length === 0) {
        //    return false;
        //  }

        //  eventId = x[0].id;

        //  selectedDate = info.date;
        //  $('#calendarContainer').hide();

        //  $.ajax({
        //    url: 'eventReservation/GetEventData?productid=' + productSubGroup + '&date=' + moment(info.date).format('YYYY-MM-DD') + '&eventid=' + eventId,
        //    type: 'GET',

        //    success: function (data, status) {
        //      HandleStep1FetchResult(data);
        //      $('#WizardStep1Container').show();
        //      console.log(data);
        //    },
        //    error: function (xhr, status, error) {
        //      ////console.log(xhr.responseText);
        //      $('*').removeClass('busy');
        //    }
        //  });


        //},

        defaultDate: new Date(),
        //navLinks: true, // can click day/week names to navigate views
        //editable: true,
        //eventLimit: true, // allow "more" link when too many events
        events: [

        ]
    });

    if (productSubGroup === "104") {
        //calendar.gotoDate("2024-01-02");
        calendar.gotoDate($("#CalendarStartDate").val());
    }
    calendar.render();


    function HandleStep1FetchResult(data) {
        var $target = $('#action-1');
        $target.empty();
        $target.html(data);
        var i = $("#loadData").val();
        i++;
        $("#loadData").val(i).change();
        $('#action-1').show();
        $('.loading-indicator').hide();
    }


});
